import React, { useState, useEffect} from 'react';
import { configData } from "../config";
import { useParams } from 'react-router-dom';
import ReactDOM from "react-dom/client";
import Loading from './Loading';
import { Helmet } from 'react-helmet';
import Select from 'react-select';
import './classes/AddToEarena.css';

function AddToEarena() {

    var {uid} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [name, setName] = useState();
    const [formData, setFormData] = useState({
       course:'',
       classroom:'',
       uid:uid
      });
    
      const [errors, setErrors] = useState({});
      const [courselist, setCourseList] = useState({});
      const [classroomlist, setClassromList] = useState({});
      const [enrolledlist, setEnrolledList] = useState({});
      const[success,setSuccess] = useState('');
    const app_url = configData.APP_URL;

    useEffect(()=>{
       
    Promise.all([
      retrievePageDetails()
     ])
     .then(() => {
     
      setIsLoading(false);
    })
            
        },[])
        
    async function retrievePageDetails() {
    
        if(uid && !Number.isNaN(uid)) {
            const response = await fetch(
                 app_url+'smwwearena/getearenadetails?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )           
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setName(responsedata.data.name);
                setCourseList(responsedata.data.result);
                setClassromList(responsedata.data.classroom);
                if(responsedata.data.enrolled_list) {
                    setEnrolledList(responsedata.data.enrolled_list);
                }
            }
        }
    }
    async function retrieveClassroomDetails(course_id) {
    
        if(uid && !Number.isNaN(uid)) {
            
            const response = await fetch(app_url + 'smwwearena/getearenaclassroomdetails?id_course='+course_id, {
                 method: "GET",
  
                    headers: {
                    'Content-Type': 'application/json',
                    },
            });
             const responsedata = await response.json();
           if(responsedata.data.msg === "Success") {
               setClassromList(responsedata.data.result);
            }
        }
    }
    const handleAddChange = event => {
      const { name, value} = event.target;
      
      setFormData(prevState => ({
       ...prevState,
        [name]: value,
      }));
      if(name=="course") {
        retrieveClassroomDetails(value);
      }
    
    };
    const validate = () => {
    let tempErrors = {};
    if (!formData.course) tempErrors.course = 'Course is required';
    if (!formData.classroom) tempErrors.classroom = 'Classroom is required';
    
    setErrors(tempErrors);
    
    return Object.keys(tempErrors).length === 0;
  };
    const handleSubmit = async event => {
    event.preventDefault();
    if (validate()) {
      const postData = formData;
      const response = await fetch(app_url + 'smwwearena/addtoearena', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
        if(data.data.msg === "Success") {
               setSuccess('The applicant has been successfully added to e-Arena!');
        }
        if(data.data.enrolled_list) {
                    setEnrolledList(data.data.enrolled_list);
        }
        setFormData(prevState => ({
       ...prevState,
        'course': '',
        'classroom': '',
      }));
    }
  };
     return (
       <>
   {isLoading ? (
        <Loading />
      ) : (
        <div id="main">
 
            <div class="left"></div>

            <div class="center left-center add-to-earena-page">
                <Helmet><title>SMWW Add to E-Arena</title></Helmet>
                {success && (
          <>
          <div className="set-message-done">
            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {success}
          </div></>
          
        )}
                <h1>Application Management : e-Arena Insertion for {name}</h1>

                {enrolledlist.length > 0 && (
                    <><a href={'/user/'+uid}>{name}</a> is currently enrolled in the following e-Arena courses:<br/>
                    <ul>
                        {enrolledlist.map((item, index) => {
                 return <>
                    <li><b>{item['course_name']} </b>[{item['start_date']}]</li>
                    </>
                    
                    })}  
                    </ul><br/><br/>
          </>
        )}
                
                <form onSubmit={handleSubmit} className='add-to-earena'>
                    <table>
                        <tbody>
                            <tr>
                                <td width="25%"><b>{name}</b> Place into:</td>
                                <td>
                                    Course:<br/>
                                    <Select id="course" name="course" className='course' onChange={(val) => handleAddChange({ target: { value: val.value, name: 'course' } })} options={courselist}>
                                    </Select>
                                    
                                </td>
                                <td width="235">
                                    Classroom:<br/>
                                    <Select id="classroom" name="classroom" className='classroom' onChange={(val) => handleAddChange({ target: { value: val.value, name: 'classroom' } })} options={classroomlist}>
                                    </Select>
                                </td>
                            </tr>
                            <tr>
                                <td> </td>
                                <td><input type="submit" value="Add" /></td>
                                <td> </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>
        </div>
        )}
    </>
    
      );
      
}
export default AddToEarena;